export default {
      id: "url-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#url",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/url.svg
// module id = 140
// module chunks = 241 242 243